namespace Core {

    export interface IBusinessFarePopupScope {
        popupMessage: string;
        popupHeader: string;
        readTermsText?: string;
        continueButtonLabel?: string;
        returnButtonLabel?: string;
    }

    const template = `
        <lightbox
            show="showPopup"
            close="close()"
            header-text="popupHeader"
            lightbox-class="lightbox-confirmation-popup"
            inner-class="business-special-fare-confirm"
            >
            <div class="message-container">
                <span ng-bind-html="popupMessage"></span>
                <p>
                    <checkbox model="cm.clientRead"></checkbox>
                    <span class="read-terms-text">{{readTermsText}}​</span>
                </p>
                <div class="button-container">
                    <button class="cancel" ng-click="close()">{{returnButtonLabel}}</button>
                    <button class="continue-next-step" ng-click="confirm()" ng-disabled="!cm.clientRead">
                        {{continueButtonLabel}}
                    </button>
                </div>
            </div>
        </lightbox>
    `;

    export class BusinessFarePopupService {
        private defaultPopupScope: IBusinessFarePopupScope;

        constructor(
            private basePopupService: Core.BasePopupService,
            private resourceService: Core.ResourceService,
            $rootScope: ng.IRootScopeService
        ) {
            this.defaultPopupScope = {
                popupMessage: '',
                popupHeader: '',
                readTermsText: '',
                continueButtonLabel: '',
                returnButtonLabel: ''
            };
        }



        public showPopup(customScope: IBusinessFarePopupScope): ng.IPromise<any> {
            const defScope = this.defaultPopupScope;
            const popupParams = {
                popupContainer: 'body',
                popupScope: {
                    ...defScope,
                    ...customScope,
                    confirm: function (val) {
                        this.defer.resolve({
                            result: 'confirm'
                        });
                    },
                    close(value?) {
                        this.defer.reject({
                            result: 'close',
                            value
                        });
                        this.$rootScope.$emit('unblock');
                    }
                }
            };
            return this.basePopupService.showPopup(template, popupParams);
        }
    }

    angular.module('TR').service('businessFarePopupService', BusinessFarePopupService);
}
